import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';

export default function TriviaCompletionModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.85, y: 40 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl"
      >
        <div className="flex flex-col items-center text-center">
          {/* Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 180 }}
          >
            <CheckCircle2Icon className="h-16 w-16 text-[#2e7d32]" />
          </motion.div>

          <h2 className="mt-6 text-2xl font-semibold text-gray-800">
            Well Done!
          </h2>

          <p className="mt-3 text-gray-600 leading-relaxed">
            You've completed today's health trivia questions. Thank you for taking the time to learn more about wellness.
          </p>

          {/* Neutral encouragement */}
          <p className="mt-4 text-sm text-gray-500">
            See you tomorrow for the next set of insights!
          </p>

          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            onClick={onClose}
            className="mt-8 w-full rounded-lg bg-[#2e7d32] py-3.5 font-medium text-white shadow transition hover:bg-[#25632a]"
          >
            Return to Home
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}